import makeStyles from "utils/makeStyles";

export default makeStyles(theme => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
      },
      graphContainer: {
        height: 310,
        position: "relative",
      },
      selectHeader: {
        // marginBottom: "1rem",
        padding: "2rem 1rem 0 1rem",
      },
      // Compact (40px) filter controls, matching the Dashboard
      filterBar: {
        marginBottom: "1rem",
        "& .inputDatePicker": { height: 40 },
        "& .inputDatePicker input": {
          height: 40,
          boxSizing: "border-box",
          padding: "0 14px",
        },
        "& .MuiOutlinedInput-root": {
          minHeight: 40,
          height: 40,
          paddingTop: 0,
          paddingBottom: 0,
        },
        "& .MuiAutocomplete-input": {
          paddingTop: "0 !important",
          paddingBottom: "0 !important",
        },
        "& .MuiAutocomplete-root .MuiOutlinedInput-root": {
          flexWrap: "nowrap",
          overflow: "hidden",
        },
        "& .MuiChip-root": { height: 24 },
        "& .MuiButton-root": {
          height: 40,
          minHeight: 40,
          paddingTop: 0,
          paddingBottom: 0,
        },
      },
      wrapper: {
        padding: '1rem 1rem 2rem 1rem',
        backgroundColor: "white",
        borderRadius: "10px"
      },
      noDataMessage: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      },
      toggleWrapper: {
        display: "inline-flex",
        justifyContent: "start",
      },
}));